import { Theme } from '@mui/material/styles';

export const useStyles = () => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: (theme: Theme) => theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  drawer: {
    width: 400,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 400,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: (theme: Theme) => theme.spacing(0, 1),
    justifyContent: 'flex-end',
  },
  listItem: {
    paddingLeft: (theme: Theme) => theme.spacing(0),
    paddingRight: (theme: Theme) => theme.spacing(0),
  },
  listItemIcon: {
    minWidth: 'auto',
    marginRight: (theme: Theme) => theme.spacing(0),
  },
  content: {
    flexGrow: 1,
    paddingLeft: (theme: Theme) => theme.spacing(3),
  },
  nested: {
    paddingLeft: (theme: Theme) => theme.spacing(4),
  },
  logo: {
    width: 64,
    height: 64,
  },
  heroContent: {
    padding: (theme: Theme) => theme.spacing(28, 0, 6),
  },
  heroButtons: {
    marginTop: (theme: Theme) => theme.spacing(4),
  },
});